export enum LockScreenMode {
  /** This mode prevents the user from navigating away or
   * closing the lock screen without entering the pin */
  APP_LOCK,

  /**
   * This mode is for when a user has set that they require a PIN to switch to their account.
   * The user should be able to cancel the switch.
   */
  PROFILE_SWITCH,
}

export interface LockScreenStore {
  lock_screen: LockScreenState;
  locked_user_id?: string;

  lockApp(user_id: string): void;
  switchProfile(user_id: string): void;
}

export interface LockScreenState {
  /** The input in the lock screen */
  input: string;

  /** Whether the lock screen is being shown */
  visible?: boolean;

  /** Error displaying on the lock screen */
  error?: string;

  /** The mode that the lock screen is displaying in */
  mode?: LockScreenMode;

  /** Whether the pin is being checked  */
  checking?: boolean;

  user_id?: string;

  forgot_pin_dialog_visible?: boolean;

  forgot_pin?: boolean;

  /** The cached reset pin */
  reset_pin_input?: string;

  prompt_reset_pin?: boolean;

  confirm_reset_pin?: boolean;

  inputNumber(number: number): Promise<void>;
  removeNumber(): void;
  close(): void;
  unlock(): void;
  forgotPin(): Promise<void>;
  promptPinReset(params?: { confirm_reset?: boolean; error?: string }): void;

  openForgotPinDialog(): void;
  closeForgotPinDialog(): void;
}
